import { request } from '../request';

const login = {
  register: (data, msgConfig = { errorMsg: false, successMsg: true }) =>
    request(
      '/api/auth/register',
      'post',
      {
        ...data,
        utm_info: window
          ? {
              pub_zl_utm_source:
                window.latestChannelAttribute.expires > Date.now()
                  ? window.latestChannelAttribute.pub_zl_utm_source || undefined
                  : undefined,
              pub_zl_utm_medium:
                window.latestChannelAttribute.expires > Date.now()
                  ? window.latestChannelAttribute.pub_zl_utm_medium || undefined
                  : undefined,
              pub_zl_utm_campaign:
                window.latestChannelAttribute.expires > Date.now()
                  ? window.latestChannelAttribute.pub_zl_utm_campaign || undefined
                  : undefined,
              pub_zl_referrer:
                window.latestChannelAttribute.expires > Date.now()
                  ? window.latestChannelAttribute.pub_zl_referrer || undefined
                  : undefined,
            }
          : {},
        black_box: localStorage.getItem('vo_tong_dun_black_box'),
      },
      Object.assign(msgConfig, { isEncrypt: true }),
    ),
  login: (data, duration) =>
    request(
      '/api/auth/login',
      'post',
      {
        ...data,
        black_box: localStorage.getItem('vo_tong_dun_black_box'),
      },
      {
        errorMsg: true,
        successMsg: true,
        duration,
        isEncrypt: true,
      },
    ),
  sendEmailCode: (data) =>
    request('/api/auth/email_code/send', 'post', data, { successMsg: false }),
  emailCodeLogin: (data) =>
    request('/api/auth/email_code/login', 'post', data, { successMsg: false }),
  checkEmailRegister: (data) =>
    request('/api/auth/check_email_register', 'post', data, { successMsg: false }),
  logout: () => request('/api/customer/logout', 'post'),
  fastRegister: (data, msgConfig = { successMsg: false, errorMsg: false, isEncrypt: true }) =>
    request(
      '/api/auth/fast_register',
      'post',
      {
        ...data,
        utm_info: window
          ? {
              pub_zl_utm_source:
                window.latestChannelAttribute.expires > Date.now()
                  ? window.latestChannelAttribute.pub_zl_utm_source || undefined
                  : undefined,
              pub_zl_utm_medium:
                window.latestChannelAttribute.expires > Date.now()
                  ? window.latestChannelAttribute.pub_zl_utm_medium || undefined
                  : undefined,
              pub_zl_utm_campaign:
                window.latestChannelAttribute.expires > Date.now()
                  ? window.latestChannelAttribute.pub_zl_utm_campaign || undefined
                  : undefined,
              pub_zl_referrer:
                window.latestChannelAttribute.expires > Date.now()
                  ? window.latestChannelAttribute.pub_zl_referrer || undefined
                  : undefined,
            }
          : {},
        black_box: localStorage.getItem('vo_tong_dun_black_box'),
      },
      Object.assign(msgConfig, { isEncrypt: true }),
    ),
  sendEmail: (data) => request('/api/auth/reset_password_send_email', 'post', data),
  resetPassword: (data) => request('/api/auth/reset_password', 'post', data, { successMsg: true }),
  /* 接口会携带token过来，通过token获取用户信息 */
  thirdRedirect: (data) =>
    request('/api/auth/third_login_redirect', 'get', {
      ...data,
      black_box: localStorage.getItem('vo_tong_dun_black_box'),
    }),
  /* 老用户根据userID获取token，重构后直接登录 */
  getTokenFromUserId: (data) => request('/api/auth/get_token', 'post', data),

  reCAPTCHA: (data) => request('/tools/recaptcha/verify', 'get', data),
};

export default login;
